export const MAP_LISTING_SET_SEARCH_QUERY = 'MAP_LISTING/SET_SEARCH_QUERY';
export const MAP_LISTING_CHANGED = 'MAP_LIST/CHANGED';
